var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#727A82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.947 4.661a1.55 1.55 0 0 0-.889.802l-.108.219v8.636l.114.233c.15.303.415.569.719.718l.232.114 4.31.009 4.31.009.254-.085c.284-.095.534-.249.716-.439.167-.175 3.442-4.815 3.441-4.877 0-.078-3.309-4.73-3.497-4.917a1.889 1.889 0 0 0-.367-.271c-.425-.226-.118-.212-4.813-.211-3.969.001-4.264.005-4.422.06m8.62 1.235c.09.048.437.512 1.539 2.058.783 1.098 1.423 2.019 1.423 2.046 0 .027-.64.948-1.423 2.046-1.102 1.546-1.449 2.01-1.539 2.058-.111.06-.276.063-4.176.063H4.33l-.082-.082-.081-.082V5.997l.081-.082.082-.082h4.061c3.9 0 4.065.003 4.176.063",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentState);
export default __webpack_public_path__ + "static/media/equipment-state.ff1bbfa23228bd6885087d231503f2f5.svg";
export { ForwardRef as ReactComponent };